"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _Animation = _interopRequireDefault(require("./Animation"));

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _designLanguage = require("@doordash/design-language");

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var animationForState = function animationForState(state) {
  switch (state) {
    case _constants.States.FoodLoop:
      return _constants.FOOD_LOOP_ANIMATION_OPTIONS;

    case _constants.States.Error:
      return _constants.ERROR_ANIMATION_OPTIONS;

    case _constants.States.Success:
      return _constants.SUCCESS_ANIMATION_OPTIONS;

    case _constants.States.Loading:
    default:
      return _constants.LOADING_ANIMATION_OPTIONS;
  }
};

var keyForState = function keyForState(state) {
  switch (state) {
    case _constants.States.FoodLoop:
      return 'FOOD_LOOP';

    case _constants.States.Error:
      return 'ERROR';

    case _constants.States.Success:
      return 'SUCCESS';

    case _constants.States.Loading:
    default:
      return 'LOADING';
  }
};

var Loading = function Loading(_ref) {
  var state = _ref.state,
      color = _ref.color,
      size = _ref.size,
      _onAnimationEnd = _ref.onAnimationEnd,
      _onAnimationLoopEnd = _ref.onAnimationLoopEnd,
      props = _objectWithoutProperties(_ref, ["state", "color", "size", "onAnimationEnd", "onAnimationLoopEnd"]);

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  var propsToForward = (0, _utilities.getPropsToForward)({
    props: props,
    prefixesToForward: ['data-']
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.LoadingRoot, _extends({
    color: color || theme.Colors.LoadingDefault,
    state: state
  }, propsToForward), /*#__PURE__*/_react["default"].createElement(_Animation["default"], {
    key: keyForState(state),
    options: animationForState(state),
    width: size,
    height: size,
    onAnimationEnd: function onAnimationEnd() {
      return _onAnimationEnd(keyForState(state));
    },
    onAnimationLoopEnd: function onAnimationLoopEnd() {
      return _onAnimationLoopEnd(keyForState(state));
    }
  }));
};

Loading.Sizes = _constants.Sizes;
Loading.States = _constants.States;
Loading.Colors = _constants.Colors;
Loading.propTypes = {
  size: _propTypes["default"].oneOf(Object.values(Loading.Sizes)),
  state: _propTypes["default"].oneOf(Object.values(Loading.States)),
  color: _propTypes["default"].oneOf(Object.values(Loading.Colors), (0, _utilities.getAllPropCasesForColors)(Object.values(Loading.Colors))),
  onAnimationEnd: _propTypes["default"].func,
  onAnimationLoopEnd: _propTypes["default"].func
};
Loading.defaultProps = {
  size: Loading.Sizes.Medium,
  state: Loading.States.Loading,
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationLoopEnd: function onAnimationLoopEnd() {}
};
var _default = Loading;
exports["default"] = _default;